import { RecurrenceOptions } from '../constants-repository/recurrence.constants';

export const RECURRENCE_LABELS: Record<RecurrenceOptions, string> = {
  [RecurrenceOptions.Daily]: 'Täglich',
  [RecurrenceOptions.Weekly]: 'Wöchentlich',
  [RecurrenceOptions.Monthly]: 'Monatlich',
} as const;
